import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';

// Install BootstrapVue
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Install VueTelInput
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.use(VueTelInput);

// Install PrimeVue
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
Vue.use(PrimeVue, { ripple: true });
Vue.use(ToastService);
Vue.use(ConfirmationService);
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

// Install Component
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import MultiSelect from 'primevue/multiselect';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import SplitButton from 'primevue/splitbutton';
import Fieldset from 'primevue/fieldset';
import PickList from 'primevue/picklist';
import InputSwitch from 'primevue/inputswitch';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Dialog from 'primevue/dialog';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import Editor from 'primevue/editor';
import ProgressSpinner from 'primevue/progressspinner';
import Tooltip from 'primevue/tooltip';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';

Vue.directive('tooltip', Tooltip);

Vue.component('Button', Button);
Vue.component('Toolbar', Toolbar);
Vue.component('DataTable', DataTable);
Vue.component('Column', Column);
Vue.component('MultiSelect', MultiSelect);
Vue.component('Toast', Toast);
Vue.component('ConfirmDialog', ConfirmDialog);
Vue.component('SplitButton', SplitButton);
Vue.component('Fieldset', Fieldset);
Vue.component('PickList', PickList);
Vue.component('InputSwitch', InputSwitch);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('Dialog', Dialog);
Vue.component('ColumnGroup', ColumnGroup);
Vue.component('Row', Row);
Vue.component('Dropdown', Dropdown);
Vue.component('Checkbox', Checkbox);
Vue.component('Editor', Editor);
Vue.component('ProgressSpinner', ProgressSpinner);
Vue.component('InputText', InputText);
Vue.component('Calendar', Calendar);
Vue.component('InputNumber', InputNumber);

import VueExcelXlsx from 'vue-excel-xlsx';

Vue.use(VueExcelXlsx);
